// Assuming Api instance is imported like this:
import { Api } from '@/core/api.js'
const api = new Api()

const state = {}

const mutations = {}

const actions = {
  async editEvent ({ commit }, { matchId, eventId, payload }) {
    try {
      const uri = `camps/matches/${matchId}/log/${eventId}/edit`
      const response = await api.post(uri, payload)
      return response
    } catch (error) {
      console.error('Error editing event:', error)
      throw error
    }
  },

  async deleteEvent ({ commit }, { matchId, eventId }) {
    try {
      const uri = `camps/matches/${matchId}/log/${eventId}/delete`
      const response = await api.get(uri)
      return response
    } catch (error) {
      console.error('Error deleting event:', error)
      throw error
    }
  },

  async restoreEvent ({ commit }, { matchId, eventId }) {
    try {
      const uri = `camps/matches/${matchId}/log/${eventId}/restore`
      const response = await api.get(uri)
      return response
    } catch (error) {
      console.error('Error restoring event:', error)
      throw error
    }
  },

  async addEvent ({ commit }, { matchId, payload }) {
    try {
      const uri = `camps/matches/${matchId}/log/add`
      const response = await api.post(uri, payload)
      return response
    } catch (error) {
      console.error('Error adding event:', error)
      throw error
    }
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
